import { ellipsis } from '../utils';
/**
 * A truncation feature where the ellipsis will be placed at the end of the URL.
 *
 * @param {String} anchorText
 * @param {Number} truncateLen The maximum length of the truncated output URL string.
 * @param {String} ellipsisChars The characters to place within the url, e.g. "..".
 * @return {String} The truncated URL.
 */
export function truncateEnd(anchorText, truncateLen, ellipsisChars) {
  return ellipsis(anchorText, truncateLen, ellipsisChars);
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/autolinker/dist/es2015/truncate/truncate-end.js
// module id = null
// module chunks = 